import { Pipe, PipeTransform } from '@angular/core';
import ProjectContact from '../model/company/projectContact';

@Pipe({
  name: 'noEmptyProjectContacts',
  pure: false
})
export class NoEmptyProjectContactsPipe implements PipeTransform {
  transform(items: ProjectContact[]): ProjectContact[] {
    if (!items) {
      return items;
    }
    return items.filter(
      item => item.contact.firstName && item.company.regularName
    );
  }
}
